<template>
  <v-sheet class="homeVideoEmpty">
    <div class="homeVideoEmpty_message">
      <span> 現在、閲覧できるカメラがありません。 </span>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: 'EmptyHomeVideo',
};
</script>

<style lang="scss">
.homeVideoEmpty {
  position: relative;
  overflow: hidden;
  // center message
  &_message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 100%;
    max-width: 380px;
    font-size: 18px;
    line-height: 1.5;
  }
  &.v-sheet {
    min-width: 100%;
    padding: 0;
  }
}
</style>
